import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIDataProvider, ApiPaths, TApiResponse } from '../../api';
import { IAdminGetQuestionList, IQuestion } from '../QuestionSlice';
import { ISession } from '.';

interface IPaginationData<T> {
  limit: number;
  offset: number;
  totalDocs: number;
  docs: Array<T>;
}

const apiDataProvider = new APIDataProvider();

export const getSessionById = createAsyncThunk(
  'session/id',
  async (id: string) => {
    const response = await apiDataProvider.get<TApiResponse<ISession>>(
      `${ApiPaths.sessions}/${id}`
    );
    return response.data;
  }
);

const getQuestionList = async (data: IAdminGetQuestionList) => {
  const response = await apiDataProvider.post<
    TApiResponse<IPaginationData<IQuestion>>
  >(`${ApiPaths.sessions}/list`, data);

  return response.data;
};

export const getQuestionListBySubTopic = createAsyncThunk(
  'user/question/list',
  getQuestionList
);

export const loadMoreQuestionListBySubTopic = createAsyncThunk(
  'user/question/loadMore',
  getQuestionList
);
